import { isIdSegment } from "@/shared/lib/id-segment";

/**
 * The route to an organization's backoffice page. Shared because several
 * features link to it (a user's memberships, the organizations directory)
 * and features may not import each other.
 */

export type OrganizationKind = "VENUE" | "PROPERTY";

export function organizationPath(organizationId: string): string {
  return isIdSegment(organizationId) ? `/organizations/${organizationId}` : "/organizations";
}
